import type { Theme } from '@mui/material';

import type { Styles } from './themes';

export const muiSelectStyles = {
  filterSelect: (theme: Theme) => ({
    flex: 1,
    height: '2.5rem',
    bgcolor: theme.colors.neutral[50],
    color: theme.colors.neutral[600],
    justifyContent: 'center',
    border: 'none',
    borderRadius: '0.375rem',

    '> fieldset': {
      border: 'none',
    },
  }),

  filterPaper: {
    boxShadow: '0 0.25rem 1.4375rem 0 #00000014',
  },

  filterMenuItem: (theme: Theme) => ({
    borderRadius: '0.375rem',
    mx: '0.25rem',
    py: '0.625rem',
    color: theme.colors.neutral[500],

    '&:hover, &.Mui-focusVisible': {
      backgroundColor: 'transparent',
      color: theme.colors.neutral[800],
    },

    '&.Mui-selected, &.Mui-selected.Mui-focusVisible': {
      color: theme.colors.neutral[500],
      backgroundColor: theme.colors.primary[50],
    },
  }),
};

export const noDataAvailableStyles = {
  noDataAvailable: ({ colors }) => ({
    width: '100%',
    // Stripes generated with https://stripesgenerator.com/
    backgroundImage:
      // eslint-disable-next-line max-len
      `linear-gradient(123deg, ${colors.neutral[200]} 22.22%, ${colors.white} 22.22%, ${colors.white} 50%, ${colors.neutral[200]} 50%, ${colors.neutral[200]} 72.22%, ${colors.white} 72.22%, ${colors.white} 100%)`,
    backgroundSize: '10.73px 16.52px',
  }),
} satisfies Styles;
